import { CycleStatus } from '../constants/cycle_statuses'

/** Prefer the newest open cycle; cycles are expected newest-first. */
const preferredCycle = (cycles = []) => cycles.find((cycle) => cycle.status === CycleStatus.Open) ?? cycles[0] ?? null

export default preferredCycle
